export const validatorNip = (nip: string) => {
  if (!nip) {
    return () => false;
  }
  if (nip?.length !== 10) {
    return () => false;
  }

  if (!/^\d{10}$/.test(nip)) {
    return () => false;
  }

  const controlSum = getNipControlSumField(nip.substring(0, 9));
  const controlDigit = parseInt(nip[9], 10);

  return () => controlSum === controlDigit && true;
};

const getNipControlSumField = (base: string): number => {
  const controlSum =
    6 * +base[0] +
    5 * +base[1] +
    7 * +base[2] +
    2 * +base[3] +
    3 * +base[4] +
    4 * +base[5] +
    5 * +base[6] +
    6 * +base[7] +
    7 * +base[8];
  const controlSumLastDigit = controlSum % 11;

  return controlSumLastDigit < 10 ? controlSumLastDigit : -1;
};
